import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT } from '../config/gameConfig.js';
import { Frames } from '../utils/atlas.js';
import { buildBloodstreamBackdrop } from '../utils/bloodstreamBackdrop.js';

export class MainMenuScene extends Phaser.Scene {
  constructor() {
    super({ key: 'MainMenu' });
  }

  create() {
    buildBloodstreamBackdrop(this);

    this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT * 0.26, 'VIRUTOPIA', {
        fontFamily: 'monospace',
        fontSize: '54px',
        color: '#ff99aa',
      })
      .setOrigin(0.5);

    this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT * 0.365, 'microscopic arcade drift-survival', {
        fontFamily: 'monospace',
        fontSize: '15px',
        color: '#eeccd8',
      })
      .setOrigin(0.5);

    this.add
      .text(
        GAME_WIDTH / 2,
        GAME_HEIGHT * 0.415,
        'Ride the bloodstream • Steer against the flow • Grow carefully',
        {
          fontFamily: 'monospace',
          fontSize: '13px',
          color: '#ddaeb8',
          align: 'center',
        }
      )
      .setOrigin(0.5);

    const blink = this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT * 0.54, 'PRESS ENTER TO START', {
        fontFamily: 'monospace',
        fontSize: '17px',
        color: '#fff6f9',
      })
      .setOrigin(0.5);

    this.tweens.add({
      targets: blink,
      alpha: { from: 0.22, to: 1 },
      duration: 840,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.inOut',
    });

    this.add
      .text(
        GAME_WIDTH / 2,
        GAME_HEIGHT * 0.69,
        'WASD / arrows — steer\nCollectibles — swell toward Size 100\nThreats — WBC hunters (few early; cap rises with Score past 5000), antibodies, platelets\nShield — 2/3 charges start; pickups add stages; hits consume one\nAt Size 100: Space — decoy clones flee left; hunters chase them until gone\nRare boosts — speed, stealth, slow-motion\n\nShift+D debug • Shift+G god mode',
        {
          fontFamily: 'monospace',
          fontSize: '13px',
          color: '#e8bcc8',
          align: 'center',
          lineSpacing: 5,
        }
      )
      .setOrigin(0.5);

    this.floaters = [];
    const n = 20;
    for (let i = 0; i < n; i++) {
      const im = this.add.image(
        Math.random() * GAME_WIDTH,
        Math.random() * GAME_HEIGHT,
        'game-atlas',
        Frames.PARTICLE
      );
      im.setDepth(-6);
      im.setAlpha(0.11 + Math.random() * 0.16);
      im.setScale(0.75 + Math.random() * 1.05);
      im.speed = 14 + Math.random() * 48;
      im.phase = Math.random() * Math.PI * 2;
      this.floaters.push(im);
    }

    this.time.delayedCall(0, () => {
      this.game.canvas?.focus?.({ preventScroll: true });
    });

    const onKeyDown = (event) => {
      const confirm =
        event.key === 'Enter' ||
        event.code === 'Enter' ||
        event.code === 'NumpadEnter';
      if (confirm) {
        this.scene.start('Game');
      }
    };
    this.input.keyboard.on('keydown', onKeyDown);
    this.events.once('shutdown', () => {
      this.input.keyboard.off('keydown', onKeyDown);
    });
  }

  update(time, delta) {
    const dt = delta / 1000;
    for (const im of this.floaters) {
      im.x -= im.speed * dt;
      im.y += Math.sin(time * 0.002 + im.phase) * 26 * dt;
      if (im.x < -28) {
        im.x = GAME_WIDTH + 40 + Math.random() * 140;
        im.y = Math.random() * GAME_HEIGHT;
      }
    }
  }
}
